import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { LockKeyhole, User } from 'lucide-react';

import { authReducerActions } from '../../../store/reducers';
import { useLogin } from '../../../hooks';
import { useI18n } from '../../../i18n';
import { ROUTE_URLS } from '../../../routes';
import { AuthLayout } from '../AuthLayout';

export const Login = () => {
  const dispatch = useDispatch();
  const { t } = useI18n();
  const { isLoading, mutateAsync: login } = useLogin();

  const onFinish = async values => {
    const { data } = await login(values);
    dispatch(authReducerActions.loginUser(data));
  };

  return (
    <AuthLayout>
      <h1>{t('login.title')}</h1>
      <p className='wm-muted' style={{ margin: '6px 0 28px' }}>
        {t('login.subtitle')}
      </p>
      <Form name='login' layout='vertical' onFinish={onFinish} requiredMark={false}>
        <Form.Item label={t('login.login')} name='login'>
          <Input
            size='large'
            prefix={<User size={16} className='wm-muted' />}
            placeholder={t('login.loginPlaceholder')}
            autoComplete='username'
            autoFocus
          />
        </Form.Item>
        <Form.Item label={t('login.password')} name='password' style={{ marginBottom: 8 }}>
          <Input.Password
            size='large'
            prefix={<LockKeyhole size={16} className='wm-muted' />}
            placeholder={t('login.passwordPlaceholder')}
            autoComplete='current-password'
          />
        </Form.Item>
        <div className='wm-auth__row'>
          <Link to={ROUTE_URLS.FORGOT_PASSWORD} className='wm-auth__link'>
            {t('login.forgotPassword')}
          </Link>
        </div>
        <Button type='primary' htmlType='submit' loading={isLoading} block>
          {t('login.submit')}
        </Button>
      </Form>
    </AuthLayout>
  );
};
